import * as React from 'react';
import TableHeader from '../TableHeader';
import { default as DispatchProps } from '../../application/core/DispatchProps';
import UserOrderModel from '../../domain/UserOrder';
import { connect } from 'react-redux';
import State from '../../application/core/State';
import UserOrder from './UserOrder';
import UserOrdersRequested from '../../application/order/events/UserOrdersRequested';

interface StateProps {
    userOrders: UserOrderModel[];
    customerId: string;
}

class UserOrders extends React.PureComponent<StateProps & DispatchProps> {
    public componentDidMount(): void {
        this.props.dispatch(new UserOrdersRequested());
    }

    public render(): JSX.Element {
        const headers = [
            'Order #',
            'Date of order',
            'Delivery drop',
            'Type',
            'Total',
            'QTY',
            'Status',
            'Order confirmation',
            'Pack list',
            'Pro-forma invoice',
            'Invoice'
        ];
        return (
            <div className="card-container">
                <h1 className="card-header">MY ORDERS</h1>
                <div className="card">
                    <TableHeader headers={headers} class="user-orders-header" />
                    {this.props.userOrders.map(order => (
                        <UserOrder userOrder={order} customerId={this.props.customerId} key={order.id} link={this.orderLink} />
                    ))}
                </div>
            </div>
        );
    }

    private orderLink = (orderId: number): string => `/orders/${orderId}`;
}

const mapStateToProps = (state: State): StateProps => ({
    userOrders: state.userOrders,
    customerId: state.user.customerId
});

export default connect(mapStateToProps)(UserOrders);



// WEBPACK FOOTER //
// ./src/view/order/UserOrders.tsx